import { toast } from '@randstad-lean-mobile-factory/react-components-core';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { AllAppNews, HomeEditionService } from 'src/Services/API';

import { useAuth } from '../Authentication/useAuth';
import { QueryKeys } from '../types';

export const useFetchAllAppNews = (extraOptions?: UseQueryOptions<AllAppNews, AxiosError>) => {
  const { isAuthenticated } = useAuth();

  return useQuery<AllAppNews, AxiosError>(
    [QueryKeys.fetchAllAppNews],
    async () => {
      return await HomeEditionService.homeEditionControllerGetAllAppNews();
    },
    {
      onError: () => {
        toast.error('erreur lors de la récupération des nouveautés sur les applications');
      },
      enabled: isAuthenticated,
      staleTime: 300000,
      cacheTime: 300000,
      refetchOnWindowFocus: false,
      ...extraOptions,
    }
  );
};
